import translate from '../../translations'

export default data => {
  const str = `
        <div class="card__inner">
          ${data.tag}
          <span class="card__date">${data.date}</span>
          <a href="${data.url}">
            <h2 class="card__title">${data.title}</h2>
          </a>
          <div class="card__text">
          ${data.desc}
          </div>                                                                         
            <a href="${
  data.url
}" class="link link--medium link--blue-light mt-5" rel="nofollow">
                ${translate('KNOW_MORE')}
            </a>
        </div>`

  return str
}
